module.exports = __webpack_public_path__ + "img/arrow_prev.32844347.png";